import { useQuery } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { SUMMARY_BASE_PATH } from '../../constants/summaryBasePath';
import { getSummary } from '../../requests/getSummary';

export const useSummary = (
  definitionName: string,
  uuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getSummary>>
  >({
    queryKey: [SUMMARY_BASE_PATH, definitionName, uuid],
    queryFn: () => getSummary(constructGet, definitionName, uuid),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    onError: () => handleError('Could not load application summary.'),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'summary'),
    ...rest,
  };
};
